module.exports = __webpack_public_path__ + "static/turtle-creek-house30-306144ae44eaf3b2077de2859ac0b80f.jpg";